import type { JSX } from 'react';
import { cloneElement } from 'react';
import { AnimatePresence } from 'motion/react';
import { useLocation, useOutlet } from 'react-router-dom';

// Keys the useOutlet element, not <Outlet />, which would render the next page in the exit slot.
function AnimatedOutlet(): JSX.Element {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <AnimatePresence mode="wait">
      {outlet && cloneElement(outlet, { key: location.pathname })}
    </AnimatePresence>
  );
}

export default AnimatedOutlet;
